import React from 'react';
// Agenda Sales Follow up
const TwentyStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>

      <p>
        We noticed we haven’t heard back from you regarding our previous
        communication. In case we missed your response, we wanted to follow up
        one last time.
      </p>

      <p>
        <strong>
          The agenda for
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
          has been finalized
        </strong>
        , and this is your{' '}
        <strong>final opportunity to confirm your participation</strong>.
      </p>

      <p>
        If you’re still interested in joining us, we encourage you to complete
        your registration as soon as possible to secure your spot:
      </p>

      <p>
        👉 Register Now:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            Click Here
          </a>
        ) : (
          `[Registration Link]`
        )}
      </p>
      <p>
        Don’t miss out on this chance to be part of an impactful event featuring
        global experts, valuable publication opportunities, and meaningful
        discussions aligned with global research trends.
      </p>
      <p>
        If you have any questions or need assistance, feel free to reach out.
        We’d be happy to help!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwentyStepTemplate;
